export default __webpack_public_path__ + "static/media/home.309218f7.jpeg";